import { useEffect } from 'react';

import sendQaEvent from '@core/googleAnalytics/dataLayer';
import useConfig from '@hooks/useConfig';
import { componentLoader } from '@utils/componentLoader';

const HeroSlice = componentLoader('HeroSlice');
const RetrieveOfferSlice = componentLoader('RetrieveOfferSlice');
const AccountButtonsSlice = componentLoader('AccountButtonsSlice');
const BenefitsSlice = componentLoader('Benefits');
const AccordionSlice = componentLoader('AccordionFaq');

export const LandingPage = () => {
  const { gaClientName, gaTrackingId } = useConfig();

  useEffect(() => {
    if (gaTrackingId) {
      sendQaEvent('homePageView', {
        clientName: gaClientName,
        event: 'spa-pageview',
        category: 'home',
        pageName: 'home'
      });
    }
  }, [gaClientName, gaTrackingId]);

  return (
    <div className='text-center text-neutral-100'>
      <HeroSlice />
      <RetrieveOfferSlice />
      <BenefitsSlice />
      <AccountButtonsSlice />
      <AccordionSlice />
    </div>
  );
};
